// import router from '../../router';
// import Router from 'vue-router'
import Vue from 'vue'
// const routerPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//     return routerPush.call(this, location).catch(error => error)
// }
// // 创建vue实例
let _this = new Vue();
const picUrls = [
    'https://cdn.mvcsky.com/'
];
let commonMethods = {
    /**
     * @function quickSort 快速排序
     * @param { Array } arr 需要排序的数组
     */
    quickSort(arr) {
        // 数组长度小于等于1时，停止递归
        if(arr.length <= 1) {
            return arr;
        }
        let left = [], right = [], flag = arr.shift();
        for(let i = 0; i < arr.length; i++) {
            if(flag > arr[i]) {
                left.push(arr[i]);
            } else {
                right.push(arr[i]);
            }
        }
        return [...this.quickSort(left), flag, ...this.quickSort(right)];
    },
    /**
     * @function getRandom 获取[n, m]区间的随机整数
     * @param {*} num1 
     * @param {*} num2 
     */
    getRandom(num1, num2){
        switch(arguments.length){
            case 1:
                return Math.floor(Math.random()*arguments[0]+1); //返回0-max的随机整数
            case 2:
                var min = arguments[0],
                    max = arguments[1];
                if(arguments[0]-arguments[1]>0){
                    min = arguments[1];
                    max = arguments[0];
                }
                return Math.floor(Math.random()*(max-min+1) + min); //返回min-max的随机整数
            default: return 0;
        }
    },
    /**
     * @function jointPicUrl 拼接图片路径
     * @param { string } url 
     */
    jointPicUrl(url) {
        let isHttp = String(url).slice(0, 4);
        if(isHttp === 'http') {
            return url;
        }
        return picUrls[0] + url;
    },
    /**
     * @function transformTime 转换时间
     * @param { string } t 需要转换的时间
     * @param {*} iss 是否需要"秒"
     */
    transformTime(t, iss) {
        let date = new Date(t);
        let y = date.getFullYear(), 
            m = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1, 
            d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate(),
            h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours(), 
            f = date.getUTCMinutes() < 10 ? '0' + date.getUTCMinutes() : date.getUTCMinutes(), 
            s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
        let time = iss ? `${y}-${m}-${d} ${h}:${f}:${s}` : `${y}-${m}-${d} ${h}:${f}`;
        return time;
    },
    /**
     * @function beforeAvatarUpload 图片上传格式大小判断
     */
    beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
        const isLt2M = file.size / 1024 / 1024 < 5;
        if (!isJPG) {
            _this.$message.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
            _this.$message.error('上传头像图片大小不能超过 5MB!');
        }
        return isJPG && isLt2M;
    },
    /**
     * @function beforeVideoUpload 视频上传格式大小判断
     */
    beforeVideoUpload(file) {
        let type_list = ['video/mp4', 'video/ogg', 'video/flv', 'video/avi', 'video/wmv', 'video/rmvb', 'video/mov'];
        const isJPG = type_list.indexOf(file.type) > -1;
        const isLt2M = file.size / 1024 / 1024 < 500;
        if (!isJPG) {
            _this.$message.error('上传的视频只能是 MP4/OGG/AVI 格式!');
        }
        if (!isLt2M) {
            _this.$message.error('上传的视频大小不能超过 100MB!');
        }
        return isJPG && isLt2M;
    },
    /**
     * @function notificationShow 通知消息提醒
     * @param { string } title 标题
     * @param { string } msg 消息提醒内容
     * @param { string } 消息提醒组件偏移量(与顶部距离)
     */
    notificationShow(title, msg, offset) {
        _this.$notify({
            title: title,
            message: msg,
            offset: offset
        });
    },
};
export default commonMethods


// WEBPACK FOOTER //
// ./src/common/commonMethods.js